export const config = __VARIANT_CONFIG__;
export const env = __VARIANT_ENV__;
